// Clean inline coin icon (sun-yellow), used wherever we show a coin count.
// Replaces emoji so it renders identically on every device.
export default function CoinIcon({ size = 20 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      aria-hidden="true"
      className="inline-block shrink-0 drop-shadow-[0_1px_2px_rgba(0,0,0,0.5)]"
    >
      <defs>
        <radialGradient id="coinG" cx="38%" cy="32%" r="75%">
          <stop offset="0%" stopColor="#FFE680" />
          <stop offset="55%" stopColor="#FFD100" />
          <stop offset="100%" stopColor="#E0A800" />
        </radialGradient>
      </defs>
      <circle cx="24" cy="24" r="22" fill="url(#coinG)" stroke="#B8860B" strokeWidth="2" />
      <circle cx="24" cy="24" r="16.5" fill="none" stroke="#B8860B" strokeWidth="1.5" opacity="0.55" />
      {/* stylised RB monogram */}
      <path
        d="M17 15h7.6c3.5 0 5.6 1.9 5.6 4.7 0 2-1.1 3.4-2.9 4l3.6 5.6h-4.3l-3.1-5h-1.9v5H17V15zm4.6 6.4h2.6c1.3 0 2.1-.6 2.1-1.7 0-1-.8-1.6-2.1-1.6h-2.6v3.3z"
        fill="#7a5c00"
      />
    </svg>
  );
}
